module.exports = __webpack_public_path__ + "img/MCS_Logos_KAZlat.585f5501.png";